import { IShip } from '../../../data/types/ship/ship';
import { getFuelTanks } from './fuel-tanks-size';

export const getCurrentFuelLevel = (ship: IShip): number =>
  Math.min(ship.fuel, getFuelTanks(ship));
